// extracted by mini-css-extract-plugin
export default {"attach":"attach--AoBLU","icon":"icon--ip9De"};